<ng-template #searchTemplate>
  <tr>
    <td></td>
    <td class="p-l-0 fw-bold" colspan="6">
      <ng-container *ngIf="searchResult.length > 0">
        <span *ngIf="searchResult.length <= 100"> Search result: {{searchResult.length}} nodes</span>
        <span *ngIf="searchResult.length > 100"> Search result: 100 of {{searchResult.length}} nodes shown</span>
      </ng-container>
    </td>
    <td></td>
  </tr>

  <tr *ngFor="let node of searchResult | slice:0:100; trackBy: trackByUUID">
    <td></td>
    <td class="p-l-0" colspan="2">{{ prettyPath(node) }}</td>

    <app-permission-toggles
      [config]="getConfig(node)"
      [disabled]="loading"
      (change)="permissionChanged(node, $event)"
    ></app-permission-toggles>

    <td *ngIf="resources" class="text-left">
      <app-resource-icon [resources]="node.resources" style="display: flex"></app-resource-icon>
    </td>
  </tr>
</ng-template>

<ng-template #rowTemplate let-node="node" let-depth="depth">
  <tr>
    <td [class]="'p-l-'+depth" colspan="2">
      <span style="cursor: pointer; display: inline-flex; align-items: center; gap: 0.5rem" (click)="toggleExpand(node)">
        <fa-icon
          *ngIf="!loadingChildren[node.uuid]"
          [icon]="expand[node.uuid] ? 'minus' : 'plus'"
          [class.opacity-50]="!node.children?.length"
          [style.pointer-events]="!node.children?.length ? 'none' : 'auto'"
          [fixedWidth]="true"
        >
        </fa-icon>
        <fa-icon *ngIf="loadingChildren[node.uuid]" icon="spinner" [spin]="true" [fixedWidth]="true"> </fa-icon>
        {{ node.name }}
      </span>
    </td>

    <app-permission-toggles
      [config]="getConfig(node)"
      [disabled]="loading"
      (change)="permissionChanged(node, $event)"
    ></app-permission-toggles>

    <td *ngIf="resources" class="text-left">
      <app-resource-icon [resources]="node.resources" style="display: flex"></app-resource-icon>
    </td>
  </tr>

  <ng-container *ngIf="expand[node.uuid] && node.children && node.children.length > 0">
    <ng-container
      *ngFor="let child of node.children; trackBy: trackByUUID"
      [ngTemplateOutlet]="rowTemplate"
      [ngTemplateOutletContext]="{node: child, depth: depth+1}"
    ></ng-container>
  </ng-container>
</ng-template>

<!-- Table -->

<table class="table table-responsive">
  <thead>
    <tr>
      <td style="width: 2.5em"></td>
      <th class="text-start p-l-0">Name</th>
      <th>
        <input
          class="form-control"
          type="text"
          placeholder="Search"
          [(ngModel)]="searchModel"
          id="search"
          (keyup)="searchTerm.next(searchModel)"
        />
      </th>
      <td></td>
      <th class="text-start">Read</th>
      <th class="text-start">Write</th>
      <th class="text-start">Delete</th>
      <th class="text-center" *ngIf="resources">Resources</th>
    </tr>
  </thead>
  <tbody *ngIf="root">
    <!-- Loading indicator -->
    <ng-container *ngIf="loading && progressMax > 10">
      <tr>
        <td colspan="8">
          <ngb-progressbar type="success" [value]="progress" [max]="progressMax"></ngb-progressbar>
        </td>
      </tr>
    </ng-container>

    <!-- All nodes sub-header  -->
    <ng-container *ngIf="searchModel.length === 0">
      <tr>
        <td></td>
        <td class="p-l-0 fw-bold" colspan="2">All</td>
        <app-permission-toggles
          [config]="getConfig(root)"
          [disabled]="loading || protect || searchModel.length > 0"
          (change)="permissionChanged(root, $event)"
        ></app-permission-toggles>
        <td *ngIf="resources"></td>
      </tr>
    </ng-container>

    <!-- Recursive node display or search results -->
    <ng-container *ngIf="searchModel.length === 0; else searchTemplate">
      <ng-container
        *ngFor="let child of root.children; trackBy: trackByUUID"
        [ngTemplateOutlet]="rowTemplate"
        [ngTemplateOutletContext]="{node: child, depth: 0}"
      ></ng-container>
    </ng-container>
  </tbody>
</table>
